module.exports = __webpack_public_path__ + "static/psychic-interior-07-6999d9eee3a227e9f25fedff240974e3.jpg";